import React, { useEffect, useState } from "react";

import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
} from "react-native";

import HomeProfile from "../componentAdmin/homeProfile";
import ManageCalendar from "../componentAdmin/manageCalendar";
import ManageSpecial from "../componentAdmin/manageSpecial";
import ManageNews from "../componentAdmin/manageNews";
import ManageAppAdmin from "../componentAdmin/manageAppAdmin";
import ManageGroups from "../componentAdmin/manageGroups";
import ManageMembers from "../componentAdmin/manageMembers";
import ManageApplications from "../componentSuperadmin/manageApplications";
import { tokenState, univer, userState } from "../reducer";
import { useRecoilState, useRecoilValue } from "recoil";
import { apiservice } from "../service/api";
import { useIsFocused } from "@react-navigation/native";
import Chat from "../componentAdmin/chat";

const { width, height } = Dimensions.get("window");

const homeAdmin = ({ navigation }) => {
  const [page, setpage] = useState(1);
  const isFocus = useIsFocused();
  const [university, setUniversity] = useRecoilState(univer);
  const [universityId, setUniversityId] = useState(null)
  const user = useRecoilValue(userState);
  const token = useRecoilValue(tokenState);

  async function getallUniversity() {
    const res = await apiservice({
      path: "/university/all",
      method: "get",
    });
    if (res.status == 200) {
      const res_user = await apiservice({
        path: "/authen/getuseradmin",
        method: "get",
        token: token.accessToken,
      });

      setUniversityId(res_user.data.result.university_id)
      setUniversity(
        res.data.result.filter((item) => {
          return item.id == res_user.data.result.university_id;
        })[0]
      );
    }
  }

  useEffect(() => {
    if (token.accessToken != undefined) {
      getallUniversity();
    }
  }, [isFocus, token]);

  if (university.theme == undefined) {
    return <View></View>;
  }

  return (
    <View style={styles.container}>
      <View
        style={{
          width: width,
          height: height * 0.1,
          backgroundColor: "#002377",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
      >
        <View style={{ marginLeft: 15 }}>
          <Image
            resizeMode={"center"}
            style={{
              width: 60,
              height: 60,
              marginHorizontal: 10,
            }}
            source={{ uri: university.logo }}
          />
        </View>
        <View
          style={{
            alignItems: "center",
            justifyContent: "flex-end",
            flexDirection: "row",
          }}
        >
          <Text style={[styles.textProfile, { color: "#FFF" }]}>
            Admin
          </Text>
          <Image
            resizeMode={"cover"}
            style={{
              width: width * 0.031,
              height: width * 0.031,
              marginRight: 30,
              marginLeft: 10,
              borderRadius: width * 0.031,
            }}
            source={{ uri: user.image_profile }}
          />
        </View>
      </View>

      <View style={{ flexDirection: "row", backgroundColor: "transparent" }}>
        <View style={{ backgroundColor: "transparent" }}>
          <View
            style={{
              width: width * 0.18,
              height: height * 0.9,
              backgroundColor: "#002377",
            }}
          >
            <TouchableOpacity
              onPress={() => setpage(1)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 1 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 1 ? "#002377" : "#ffff",
                  },
                ]}
              >
                หน้าแรก
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(2)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 2 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 2 ? "#002377" : "#ffff",
                  },
                ]}
              >
                ปฏิทิน
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(3)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 3 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 3 ? "#002377" : "#ffff",
                  },
                ]}
              >
                จัดการกลุ่ม
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(4)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 4 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 4 ? "#002377" : "#ffff",
                  },
                ]}
              >
                จัดการสมาชิก
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(5)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 5 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 5 ? "#002377" : "#ffff",
                  },
                ]}
              >
                ข่าวสาร
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(6)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 6 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 6 ? "#002377" : "#ffff",
                  },
                ]}
              >
                สิทธิพิเศษ
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(7)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 7 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 7 ? "#002377" : "#ffff",
                  },
                ]}
              >
                จัดการแอพพลิเคชั่น
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => setpage(8)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 8 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 8 ? "#002377" : "#ffff",
                  },
                ]}
              >
                จัดการธีม
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => setpage(9)}
              style={[
                styles.boxSection,
                {
                  backgroundColor: page == 9 ? "#ffff" : "#002377",
                },
              ]}
            >
              <Text
                style={[
                  styles.textSection,
                  {
                    color: page == 9 ? "#002377" : "#ffff",
                  },
                ]}
              >
                แชท
              </Text>
            </TouchableOpacity>

            <View
              style={{
                width: width * 0.15,
                height: 10,
                justifyContent: "center",
                borderTopWidth: 1,
                alignSelf: "center",
                borderTopColor: "#ffff",
                marginTop: 16,
              }}
            ></View>

            <TouchableOpacity
              style={[
                styles.boxSection,
                { backgroundColor: "#002377" },
              ]}
              onPress={() => {
                navigation.navigate("Login");
              }}
            >
              <Text
                style={[styles.textSection, { color: "#fff" }]}
              >
                ออกจากระบบ
              </Text>
            </TouchableOpacity>
          </View>
        </View>
        {page == 1 && <HomeProfile users={user} />}
        {page == 2 && <ManageCalendar />}
        {page == 3 && <ManageGroups />}
        {page == 4 && <ManageMembers />}
        {page == 5 && <ManageNews />}
        {page == 6 && <ManageSpecial />}
        {page == 7 && <ManageAppAdmin />}
        {page == 8 && <ManageApplications />}
        {page == 9 && <Chat universityId={universityId} />}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  textSection: {
    fontSize: 16,
    color: "#ffff",
    paddingLeft: 50,
    fontFamily: "Prompt-Regular",
  },
  boxSection: {
    width: width * 0.18,
    height: height * 0.055,
    justifyContent: "center",
  },
  textProfile: {
    fontSize: 18,
    color: "#ffff",
    fontFamily: "Prompt-Regular"
  },
});
export default homeAdmin;
